import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";

export default function BookingCancel() {
  return (
    <div data-testid="booking-cancel-page" className="min-h-screen bg-melissa-bg flex items-center justify-center p-6">
      <div className="w-full max-w-xl bg-melissa-bg2 border border-melissa-border p-10 md:p-14 text-center">
        <AlertCircle className="mx-auto mb-6 text-melissa-rose" size={40} />
        <p className="text-xs uppercase tracking-overline text-melissa-rose mb-3">Deposit not completed</p>
        <h1 className="font-serif font-light text-4xl md:text-5xl text-melissa-ink leading-tight">
          Your seat is still warm.
        </h1>
        <p className="mt-4 text-melissa-inkSoft font-light leading-relaxed max-w-md mx-auto">
          We saved your inquiry, but the date isn't reserved until the $50 deposit is paid.
          Come back any time — Melissa will also reach out within 48 hours.
        </p>
        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <Link
            to="/#contact"
            data-testid="booking-cancel-retry"
            className="px-7 py-4 bg-melissa-ink text-melissa-bg text-xs uppercase tracking-overline hover:bg-melissa-rose"
          >
            Try Again
          </Link>
          <Link
            to="/"
            data-testid="booking-cancel-home"
            className="px-7 py-4 border border-melissa-ink text-xs uppercase tracking-overline hover:bg-melissa-ink hover:text-melissa-bg"
          >
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
}
